module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_100_Active@1x-1e2f386b0be0882143085333fc3b27e0.png";